// Words guests type that a whole category should answer to. Every place in
// the category is found by them; a place's own `tags` (in restaurants.ts and
// attractions.ts) cover what makes it specific.

export const CATEGORY_WORDS: Record<string, string[]> = {
  // Restaurants
  'Sit down dinner': ['dinner', 'restaurant', 'sit down', 'nice dinner'],
  'Brunch Food & Drink': ['brunch', 'breakfast', 'eggs', 'mimosa', 'weekend'],
  'Speakeasies & Cocktails': ['bar', 'drinks', 'cocktail', 'nightlife', 'date night', 'speakeasy'],
  'Asian Eats': ['asian', 'noodles', 'rice'],
  'Fast Eats': ['fast food', 'quick', 'cheap', 'casual', 'lunch', 'takeout'],
  'Coffee & Cafés': ['coffee', 'cafe', 'espresso', 'latte', 'breakfast', 'work friendly'],
  'Sweets & Treats': ['dessert', 'sweet', 'treat', 'bakery', 'pastry', 'snack'],
  'Fremont & Ballard Eats': ['fremont', 'ballard'],
  'Pike Place / Waterfront': ['pike place', 'market', 'waterfront', 'water view'],
  'Downtown Dining': ['downtown'],
  // Things to do
  'Capitol Hill Hit List': ['things to do', 'nearby', 'walkable', 'capitol hill'],
  'Space Needle & Seattle Center': ['seattle center', 'space needle', 'sightseeing', 'tourist', 'landmark'],
  'Fremont & Ballard': ['things to do', 'fremont', 'ballard'],
  'University District': ['things to do', 'university', 'u district', 'uw'],
  'Pike Place Market / Waterfront': ['sightseeing', 'tourist', 'downtown', 'waterfront'],
  'Lake Union': ['lake union', 'water', 'boat', 'outdoors'],
};
